import React from 'react';
import TicketArchivedList from '../js/TicketArchivedList';

function ArchivedTickets () {
    return (<TicketArchivedList/>);
};

export default ArchivedTickets;